import axios from 'axios';

// Instância isolada da sessão de administrador de plataforma — usa chaves de
// localStorage próprias (admin_plataforma_*), nunca as mesmas do login de
// clientes (token/refresh_token/user), para as duas sessões poderem coexistir
// sem se misturar num mesmo navegador.
export const apiAdminPlataforma = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

apiAdminPlataforma.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_plataforma_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function limparSessaoAdminPlataforma() {
  ['admin_plataforma_token', 'admin_plataforma_refresh', 'admin_plataforma_user'].forEach(
    (k) => localStorage.removeItem(k)
  );
  window.location.href = '/admin-plataforma/login';
}

let refreshEmAndamento = null;

function renovarToken() {
  if (!refreshEmAndamento) {
    const refreshToken = localStorage.getItem('admin_plataforma_refresh');
    if (!refreshToken) {
      refreshEmAndamento = Promise.reject(new Error('Sem refresh token disponível.'));
    } else {
      refreshEmAndamento = axios
        .post(`${process.env.REACT_APP_API_URL}/api/auth/refresh/`, { refresh: refreshToken })
        .then((res) => {
          localStorage.setItem('admin_plataforma_token', res.data.access);
          if (res.data.refresh) {
            localStorage.setItem('admin_plataforma_refresh', res.data.refresh);
          }
          return res.data.access;
        })
        .finally(() => {
          refreshEmAndamento = null;
        });
    }
  }
  return refreshEmAndamento;
}

apiAdminPlataforma.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { config, response } = error;
    if (response?.status === 401 && !config._tentouRenovar) {
      config._tentouRenovar = true;
      try {
        const novoAccess = await renovarToken();
        config.headers.Authorization = `Bearer ${novoAccess}`;
        return apiAdminPlataforma(config);
      } catch {
        limparSessaoAdminPlataforma();
        return Promise.reject(error);
      }
    }
    if (response?.status === 401) {
      limparSessaoAdminPlataforma();
    }
    return Promise.reject(error);
  }
);
